export default __webpack_public_path__ + "static/media/silvia3.bb407e64.png";